webpackJsonp([1],{

/***/ 167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Timeline__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Event__ = __webpack_require__(228);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Chart',
  data: function data() {
    return {
      clicked: {},
      isScrolled: false,
      windowSize: window.screen.width,
      rooms: [{
        id: 7,
        floor: 7,
        roomList: [{
          roomName: 'Ржавый Фред',
          roomCount: '3 – 6 человек',
          isFull: false
        }, {
          roomName: 'Прачечная',
          roomCount: 'до 10 человек',
          isFull: false
        }, {
          roomName: 'Желтый дом',
          roomCount: 'до 10 человек',
          isFull: false
        }, {
          roomName: 'Оранжевый Тюльпан',
          roomCount: '3 – 6 человек',
          isFull: false
        }]
      }, {
        id: 6,
        floor: 6,
        roomList: [{
          roomName: 'Джокер',
          roomCount: '3 – 6 человек',
          isFull: false
        }, {
          roomName: 'Мариванна',
          roomCount: 'до 10 человек',
          isFull: false
        }, {
          roomName: 'Тонкий Боб',
          roomCount: 'до 10 человек',
          isFull: false
        }]
      }],
      currentTarget: null
    };
  },

  methods: {
    setScrollLeft: function setScrollLeft(e) {
      this.isScrolled = e.target.scrollLeft >= 250;
    },
    openNewEventModal: function openNewEventModal(event) {
      this.$store.commit('setCurrentEvent', null);
      this.$store.commit('setNewEventModal', true);
      this.$store.commit('setEventModal', false);
      this.$store.commit('setCurrentTheme', null);
      this.$store.commit('clearSelectedMembers');
      this.$store.commit('setCurrentRoom', event.target.dataset.room);
      if (event.target.dataset.start < 10) {
        this.$store.commit('setStartTime', '0' + event.target.dataset.start + ':00');
      } else {
        this.$store.commit('setStartTime', event.target.dataset.start + ':00');
      }
      if (event.target.dataset.end < 10) {
        this.$store.commit('setEndTime', '0' + event.target.dataset.end + ':00');
      } else {
        this.$store.commit('setEndTime', event.target.dataset.end + ':00');
      }
      this.$store.commit('setCurrentFloor', event.target.dataset.floor);
    },
    getWidth: function getWidth(cell) {
      var startTime = cell.startTime;
      var endTime = cell.endTime;
      var hours = endTime.slice(0, 2) - startTime.slice(0, 2);
      var minutes = endTime.slice(3, 5) - startTime.slice(3, 5);
      if (this.windowSize < 1366) {
        return hours * 67 + minutes * 1.116;
      }
      return hours * 67.2 + minutes * 1.12;
    },
    getLeftPosition: function getLeftPosition(cell) {
      var startTime = cell.startTime;
      var hours = startTime.slice(0, 2);
      var minutes = startTime.slice(3, 5);
      if (this.window < 1366) {
        return hours * 67 + minutes * 1.116 - 470.4;
      }
      return hours * 67.2 + minutes * 1.12 - 470.4;
    },
    showEventPopup: function showEventPopup(event, eventInfo, index) {
      if (this.$store.getters.getEventModal && event.target === this.currentTarget) {
        this.currentTarget = null;
        this.$store.commit('setEventModal', false);
        this.clicked = [];
        this.$set(this.clicked, index, !this.clicked[index]);
        this.$store.commit('setCurrentEvent', null);
      } else {
        this.currentTarget = event.target;
        this.$store.commit('setEventModal', true);
        this.$store.commit('setCurrentEvent', eventInfo);
        this.clicked = [];
        this.$set(this.clicked, index, true);
      }
    }
  },
  computed: {
    getEventsList: function getEventsList() {
      return this.$store.getters.getEventsList;
    },
    getSelectedDate: function getSelectedDate() {
      var date = this.$store.getters.getSelectedDate;
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD');
    },
    getCurrentEvent: function getCurrentEvent() {
      return this.$store.getters.getCurrentEvent;
    }
  },
  components: {
    Timeline: __WEBPACK_IMPORTED_MODULE_1__Timeline__["a" /* default */],
    Event: __WEBPACK_IMPORTED_MODULE_2__Event__["a" /* default */]
  }
});

/***/ }),

/***/ 168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);


//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Timeline',
  data: function data() {
    return {
      times: [{
        time: 8,
        isPast: false
      }, {
        time: 9,
        isPast: false
      }, {
        time: 10,
        isPast: false
      }, {
        time: 11,
        isPast: false
      }, {
        time: 12,
        isPast: false
      }, {
        time: 13,
        isPast: false
      }, {
        time: 14,
        isPast: false
      }, {
        time: 15,
        isPast: false
      }, {
        time: 16,
        isPast: false
      }, {
        time: 17,
        isPast: false
      }, {
        time: 18,
        isPast: false
      }, {
        time: 19,
        isPast: false
      }, {
        time: 20,
        isPast: false
      }, {
        time: 21,
        isPast: false
      }, {
        time: 22,
        isPast: false
      }, {
        time: 23,
        isPast: false
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    var now = this.getCurrentDate;
    var hour = now.getHours();
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(this.times).forEach(function (_ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 1),
          key = _ref2[0];

      if (_this.times[key].time < hour) {
        _this.times[key].isPast = true;
      }
    });
  },

  computed: {
    getCurrentTime: function getCurrentTime() {
      var now = this.getCurrentDate;
      var minutes = now.getMinutes();
      var hour = now.getHours();
      if (minutes < 10) {
        return hour + ':0' + minutes;
      }
      return hour + ':' + minutes;
    },
    getTimelineLeftPosition: function getTimelineLeftPosition() {
      var now = this.getCurrentDate;
      var minutes = now.getMinutes();
      var hour = now.getHours();
      var totalHours = (hour - 7 + minutes / 60).toFixed(1);
      var getWindowSize = window.screen.width;
      if (getWindowSize < 1366) {
        if (hour > 23 || hour < 7) {
          return '1295px';
        }
        return 153 + totalHours * 67 + 'px';
      }
      if (hour > 23 || hour < 7) {
        return '1340px';
      }
      return 220 + totalHours * 67.2 + 'px';
    },
    getCurrentDate: function getCurrentDate() {
      return this.$store.getters.getCurrentDate;
    }
  }
});

/***/ }),

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Event',
  methods: {
    getCorrectEnding: function getCorrectEnding(number, word) {
      var cases = [2, 0, 1, 1, 1, 2];
      return word[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]];
    },
    editSelectedEvent: function editSelectedEvent() {
      var currentEvent = this.getCurrentEvent;
      var events = this.getEventsList;
      var index = events.indexOf(events.find(function (obj) {
        return obj.id === currentEvent.id;
      }));
      this.$store.commit('setEdit', true);
      this.$store.commit('setEditIndex', index);
      this.$store.commit('setCurrentRoom', currentEvent.room);
      this.$store.commit('setStartTime', currentEvent.startTime);
      this.$store.commit('setEndTime', currentEvent.endTime);
      this.$store.commit('setCurrentFloor', currentEvent.floor);
      this.$store.commit('setSelectedMembers', currentEvent.members);
      this.$store.commit('setCurrentTheme', currentEvent.theme);
      this.$store.commit('setSelectedDate', currentEvent.date);
      this.$store.commit('setNewEventModal', true);
    }
  },
  computed: {
    isOpened: function isOpened() {
      return this.$store.getters.getEventModal;
    },
    getLeftPosition: function getLeftPosition() {
      return -172 + 'px';
    },
    getTopPosition: function getTopPosition() {
      return 36 + 'px';
    },
    getCurrentEvent: function getCurrentEvent() {
      return this.$store.getters.getCurrentEvent;
    },
    getCurrentEventDate: function getCurrentEventDate() {
      var date = this.getCurrentEvent.date;
      __WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale('ru');
      return '' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('DD MMMM');
    },
    getMembersCount: function getMembersCount() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.getCurrentEvent.members).length;
    },
    getEventsList: function getEventsList() {
      return this.$store.getters.getEventsList;
    }
  }
});

/***/ }),

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuejs_datepicker_dist_locale__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__EventDeletePopup__ = __webpack_require__(256);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      language: __WEBPACK_IMPORTED_MODULE_7_vuejs_datepicker_dist_locale__["a" /* ru */],
      selectedMembers: [],
      isThemeValid: false,
      isDateValid: false,
      isTimeValid: false,
      isMembersValid: false,
      isRoomValid: false,
      rooms: [{
        id: 7,
        floor: 7,
        roomList: [{
          roomName: 'Ржавый Фред',
          roomCount: '3 – 6 человек',
          isFull: false
        }, {
          roomName: 'Прачечная',
          roomCount: 'до 10 человек',
          isFull: false
        }, {
          roomName: 'Желтый дом',
          roomCount: 'до 10 человек',
          isFull: false
        }, {
          roomName: 'Оранжевый Тюльпан',
          roomCount: '3 – 6 человек',
          isFull: false
        }]
      }, {
        id: 6,
        floor: 6,
        roomList: [{
          roomName: 'Джокер',
          roomCount: '3 – 6 человек',
          isFull: false
        }, {
          roomName: 'Мариванна',
          roomCount: 'до 10 человек',
          isFull: false
        }, {
          roomName: 'Тонкий Боб',
          roomCount: 'до 10 человек',
          isFull: false
        }]
      }],
      freeRooms: [{
        roomName: 'Ржавый Фред',
        roomCount: '3 – 6 человек',
        floor: 7
      }, {
        roomName: 'Прачечная',
        roomCount: 'до 10 человек',
        floor: 7
      }, {
        roomName: 'Желтый дом',
        roomCount: 'до 10 человек',
        floor: 7
      }, {
        roomName: 'Оранжевый Тюльпан',
        roomCount: '3 – 6 человек',
        floor: 7
      }, {
        roomName: 'Джокер',
        roomCount: '3 – 6 человек',
        floor: 6
      }, {
        roomName: 'Мариванна',
        roomCount: 'до 10 человек',
        floor: 6
      }, {
        roomName: 'Тонкий Боб',
        roomCount: 'до 10 человек',
        floor: 6
      }]
    };
  },

  name: 'NewEvent',
  mounted: function mounted() {
    if (this.getEditState) {
      this.selectedMembers = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(this.getSelectedMembers);
    }
  },

  computed: {
    getId: function getId() {
      return this.$store.getters.getId;
    },
    getEditIndex: function getEditIndex() {
      return this.$store.getters.getEditIndex;
    },
    getEditState: function getEditState() {
      return this.$store.getters.getEditState;
    },
    isModalOpened: function isModalOpened() {
      return this.$store.getters.getNewEventModal;
    },
    getCurrentRoom: function getCurrentRoom() {
      return this.$store.getters.getCurrentRoom;
    },
    getCurrentTime: function getCurrentTime() {
      return this.$store.getters.getCurrentTime;
    },
    getCurrentFloor: function getCurrentFloor() {
      return this.$store.getters.getCurrentFloor;
    },
    getSelectedDate: function getSelectedDate() {
      var date = this.$store.getters.getSelectedDate;
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(date).format('YYYY-MM-DD');
    },
    getStartTime: function getStartTime() {
      return this.$store.getters.getStartTime;
    },
    getEndTime: function getEndTime() {
      return this.$store.getters.getEndTime;
    },

    startTime: {
      get: function get() {
        return this.getStartTime;
      },
      set: function set(value) {
        this.$store.commit('setStartTime', value);
      }
    },
    endTime: {
      get: function get() {
        return this.getEndTime;
      },
      set: function set(value) {
        this.$store.commit('setEndTime', value);
      }
    },
    getAllMembers: function getAllMembers() {
      return this.$store.getters.getAllMembers;
    },
    getSelectedMembers: function getSelectedMembers() {
      return this.$store.getters.getSelectedMembers;
    },
    getCurrentDate: function getCurrentDate() {
      var now = this.$store.getters.getCurrentDate;
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(now).format('YYYY-MM-DD');
    },

    currentTheme: {
      get: function get() {
        return this.$store.getters.getCurrentTheme;
      },
      set: function set(value) {
        this.$store.commit('setCurrentTheme', value);
      }
    },
    themeValidation: function themeValidation() {
      if (this.currentTheme == null || this.currentTheme.length === 0) {
        this.isThemeValid = false;
        return 'Тема обязательна к заполнению';
      } else if (this.currentTheme.length < 4) {
        this.isThemeValid = false;
        return 'Тема должна состоять как минимум из 4 символов';
      }
      this.isThemeValid = true;
      return '';
    },
    dateValidation: function dateValidation() {
      var now = new Date();
      var today = __WEBPACK_IMPORTED_MODULE_5_moment___default()(now).format('YYYY-MM-DD');
      if (this.getSelectedDate === 'Invalid date') {
        this.isDateValid = false;
        return 'Необходимо выбрать дату';
      } else if (new Date(this.getSelectedDate).getTime() < new Date(today).getTime()) {
        this.isDateValid = false;
        return 'Дата должна быть больше или равна текущей';
      }
      this.isDateValid = true;
      return '';
    },
    timeValidation: function timeValidation() {
      var _this = this;

      var reg = /([01]?[0-9]|2[0-3]):[0-5][0-9]/;
      var date = __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.$store.getters.getSelectedDate).format('YYYY-MM-DD');
      var eventsList = this.$store.getters.getEventsList;
      var room = this.getCurrentRoom;
      var startTime = this.getStartTime;
      var endTime = this.getEndTime;
      if (this.endTime <= this.startTime) {
        this.isTimeValid = false;
        return 'Начало должно быть раньше конца';
      } else if (this.startTime.slice(0, 2) < new Date().getHours()) {
        this.isTimeValid = false;
        return 'Время уже прошло';
      } else if (this.startTime < '07:00') {
        this.isTimeValid = false;
        return 'Переговорки доступны с 7:00';
      } else if (this.endTime > '23:59') {
        this.isTimeValid = false;
        return 'Переговорки доступны до 23:59';
      } else if (!reg.test(this.startTime) || !reg.test(this.endTime)) {
        this.isTimeValid = false;
        return 'Введите время в формате ЧЧ:ММ';
      } else if (eventsList.length === 1 && eventsList[0] === this.$store.getters.getCurrentEvent) {
        this.isTimeValid = true;
        return '';
      } else if (eventsList.length > 0) {
        return eventsList.filter(function (obj) {
          return obj !== _this.$store.getters.getCurrentEvent;
        }).map(function (obj) {
          if (obj.room === room && obj.date === date) {
            if (startTime >= obj.startTime && startTime <= obj.endTime) {
              _this.isTimeValid = false;
              return '\u041F\u0435\u0440\u0435\u0433\u043E\u0432\u043E\u0440\u043A\u0430 \u0437\u0430\u043D\u044F\u0442\u0430 c ' + obj.startTime + ' \u0434\u043E ' + obj.endTime;
            } else if (endTime >= obj.startTime && endTime <= obj.endTime) {
              _this.isTimeValid = false;
              return '\u041F\u0435\u0440\u0435\u0433\u043E\u0432\u043E\u0440\u043A\u0430 \u0437\u0430\u043D\u044F\u0442\u0430 c ' + obj.startTime + ' \u0434\u043E ' + obj.endTime;
            } else if (startTime <= obj.startTime && endTime >= obj.endTime) {
              _this.isTimeValid = false;
              return '\u041F\u0435\u0440\u0435\u0433\u043E\u0432\u043E\u0440\u043A\u0430 \u0437\u0430\u043D\u044F\u0442\u0430 c ' + obj.startTime + ' \u0434\u043E ' + obj.endTime;
            }
          }
          _this.isTimeValid = true;
          return '';
        });
      }
      this.isTimeValid = true;
      return '';
    },
    membersValidation: function membersValidation() {
      var _this2 = this;

      var counter = null;
      if (this.getCurrentRoom) {
        // eslint-disable-next-line max-len
        var floorIndex = this.rooms.indexOf(this.rooms.find(function (obj) {
          return obj.id === +_this2.getCurrentFloor;
        }));
        // eslint-disable-next-line max-len
        var roomIndex = this.rooms[floorIndex].roomList.indexOf(this.rooms[floorIndex].roomList.find(function (room) {
          return room.roomName === _this2.getCurrentRoom;
        }));
        var roomCount = this.rooms[floorIndex].roomList[roomIndex].roomCount;
        if (roomCount === '3 – 6 человек') {
          counter = 6;
        } else {
          counter = 10;
        }
      }
      if (this.selectedMembers.length === 0) {
        this.isMembersValid = false;
        return 'Нужно выбрать хотя бы одного участника';
      } else if (this.getCurrentRoom) {
        if (this.selectedMembers.length > counter) {
          this.isMembersValid = false;
          return '\u041F\u0440\u0435\u0432\u044B\u0448\u0435\u043D \u043B\u0438\u043C\u0438\u0442 \u043A\u043E\u043C\u043D\u0430\u0442\u044B. \u041C\u0430\u043A\u0441\u0438\u043C\u0443\u043C ' + counter + ' \u0447\u0435\u043B\u043E\u0432\u0435\u043A';
        }
      }
      this.isMembersValid = true;
      return '';
    },
    roomValidation: function roomValidation() {
      if (!this.getCurrentRoom || !this.getCurrentFloor) {
        this.isRoomValid = false;
        return 'Нужно выбрать переговорку';
      }
      this.isRoomValid = true;
      return '';
    },
    isFormValid: function isFormValid() {
      // eslint-disable-next-line max-len
      return this.isThemeValid && this.isDateValid && this.isTimeValid && this.isMembersValid && this.isRoomValid;
    }
  },
  methods: {
    setCurrentRoom: function setCurrentRoom(roomName, floor) {
      this.$store.commit('setCurrentRoom', roomName);
      this.$store.commit('setCurrentFloor', floor);
    },
    removeCurrentRoom: function removeCurrentRoom() {
      this.$store.commit('setCurrentRoom', null);
      this.$store.commit('setCurrentFloor', null);
    },
    setEventDeleteModal: function setEventDeleteModal() {
      this.$store.commit('setEventDeleteModal', true);
    },
    customFormatter: function customFormatter(date) {
      __WEBPACK_IMPORTED_MODULE_5_moment___default.a.locale('ru');
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(date).format('LL');
    },
    endTimeKeyPressed: function endTimeKeyPressed(e) {
      if (this.endTime.length > 4) {
        e.target.value = this.endTime.slice(0, 4);
      }
    },
    startTimeKeyPressed: function startTimeKeyPressed(e) {
      if (this.startTime.length > 4) {
        e.target.value = this.startTime.slice(0, 4);
      }
    },
    closeNewEventModal: function closeNewEventModal() {
      this.$store.commit('setNewEventModal', false);
      this.$store.commit('setEdit', false);
      this.$store.commit('setEditIndex', null);
      this.$store.commit('setCurrentEvent', null);
      this.$store.commit('setEventModal', false);
      this.selectedMembers = [];
    },
    setSelectedMembers: function setSelectedMembers(value) {
      this.$store.commit('setSelectedMembers', value);
    },
    changeSelectedDate: function changeSelectedDate(value) {
      this.$store.commit('setSelectedDate', value);
    },
    deleteSelectedMember: function deleteSelectedMember(name) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(this.selectedMembers).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        if (value.name === name) {
          __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].delete(_this3.selectedMembers, key);
        }
      });
      this.$store.commit('deleteSelectedMember', name);
    },
    submitRoom: function submitRoom() {
      if (this.getEditState) {
        var eventObj = {
          id: this.$store.getters.getCurrentEvent.id,
          floor: this.getCurrentFloor,
          room: this.getCurrentRoom,
          theme: this.currentTheme,
          date: this.getSelectedDate,
          startTime: this.getStartTime,
          endTime: this.getEndTime,
          members: this.getSelectedMembers
        };
        this.$store.commit('updateEvent', eventObj);
        this.$store.commit('setEdit', false);
        this.$store.commit('setEditIndex', null);
        this.$store.commit('setNewEventModal', false);
        this.$store.commit('setEventCreatedModal', true);
        this.$store.commit('setCurrentEvent', eventObj);
      } else {
        var _eventObj = {
          id: this.getId,
          floor: this.getCurrentFloor,
          room: this.getCurrentRoom,
          theme: this.currentTheme,
          date: this.getSelectedDate,
          startTime: this.getStartTime,
          endTime: this.getEndTime,
          members: this.getSelectedMembers
        };
        this.$store.commit('setNewEvent', _eventObj);
        this.$store.commit('setNewEventModal', false);
        this.$store.commit('setEventCreatedModal', true);
        this.$store.commit('setId', 1);
        this.selectedMembers = [];
      }
    }
  },
  filters: {
    formatMessage: function formatMessage(value) {
      if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === 'object') {
        return String(value.filter(function (string) {
          return string.includes('Переговорка');
        }));
      }
      return value;
    }
  },
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker__["a" /* default */],
    EventDelete: __WEBPACK_IMPORTED_MODULE_8__EventDeletePopup__["a" /* default */]
  }
});

/***/ }),

/***/ 181:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EventDeletePopup',
  methods: {
    setEventDeleteModal: function setEventDeleteModal() {
      this.$store.commit('setEventDeleteModal', false);
    },
    deleteCurrentEvent: function deleteCurrentEvent() {
      this.$store.commit('deleteCurrentEvent');
      this.setEventDeleteModal();
      this.$store.commit('setNewEventModal', false);
      this.$store.commit('setEdit', false);
      this.$store.commit('setEditIndex', null);
    }
  },
  computed: {
    getEventDeleteModal: function getEventDeleteModal() {
      return this.$store.getters.getEventDeleteModal;
    }
  }
});

/***/ }),

/***/ 182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EventCreated',
  computed: {
    getEventCreatedModal: function getEventCreatedModal() {
      return this.$store.getters.getEventCreatedModal;
    },
    getCurrentRoom: function getCurrentRoom() {
      return this.$store.getters.getCurrentRoom;
    },
    getCurrentFloor: function getCurrentFloor() {
      return this.$store.getters.getCurrentFloor;
    },
    getStartTime: function getStartTime() {
      return this.$store.getters.getStartTime;
    },
    getEndTime: function getEndTime() {
      return this.$store.getters.getEndTime;
    },
    getSelectedDate: function getSelectedDate() {
      var date = this.$store.getters.getSelectedDate;
      __WEBPACK_IMPORTED_MODULE_0_moment___default.a.locale('ru');
      return '' + __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('DD MMMM');
    }
  },
  methods: {
    setEventCreatedModal: function setEventCreatedModal() {
      this.$store.commit('setEventCreatedModal', false);
    }
  }
});

/***/ }),

/***/ 183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_select__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_index__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_btn_less__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_btn_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_btn_less__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('v-select', __WEBPACK_IMPORTED_MODULE_2_vue_select___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_4__store_index__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] }
});

/***/ }),

/***/ 189:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(39);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5af5b23a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(263);
function injectStyle (ssrContext) {
  __webpack_require__(190)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5af5b23a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 190:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageHeader_vue__ = __webpack_require__(40);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fb3645e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageHeader_vue__ = __webpack_require__(199);
function injectStyle (ssrContext) {
  __webpack_require__(193)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fb3645e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 193:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 194:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calendar_vue__ = __webpack_require__(41);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7f53d40_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calendar_vue__ = __webpack_require__(198);
function injectStyle (ssrContext) {
  __webpack_require__(195)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7f53d40_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 195:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 44,
	"./af.js": 44,
	"./ar": 45,
	"./ar-dz": 46,
	"./ar-dz.js": 46,
	"./ar-kw": 47,
	"./ar-kw.js": 47,
	"./ar-ly": 48,
	"./ar-ly.js": 48,
	"./ar-ma": 49,
	"./ar-ma.js": 49,
	"./ar-sa": 50,
	"./ar-sa.js": 50,
	"./ar-tn": 51,
	"./ar-tn.js": 51,
	"./ar.js": 45,
	"./az": 52,
	"./az.js": 52,
	"./be": 53,
	"./be.js": 53,
	"./bg": 54,
	"./bg.js": 54,
	"./bm": 55,
	"./bm.js": 55,
	"./bn": 56,
	"./bn.js": 56,
	"./bo": 57,
	"./bo.js": 57,
	"./br": 58,
	"./br.js": 58,
	"./bs": 59,
	"./bs.js": 59,
	"./ca": 60,
	"./ca.js": 60,
	"./cs": 61,
	"./cs.js": 61,
	"./cv": 62,
	"./cv.js": 62,
	"./cy": 63,
	"./cy.js": 63,
	"./da": 64,
	"./da.js": 64,
	"./de": 65,
	"./de-at": 66,
	"./de-at.js": 66,
	"./de-ch": 67,
	"./de-ch.js": 67,
	"./de.js": 65,
	"./dv": 68,
	"./dv.js": 68,
	"./el": 69,
	"./el.js": 69,
	"./en-au": 70,
	"./en-au.js": 70,
	"./en-ca": 71,
	"./en-ca.js": 71,
	"./en-gb": 72,
	"./en-gb.js": 72,
	"./en-ie": 73,
	"./en-ie.js": 73,
	"./en-il": 74,
	"./en-il.js": 74,
	"./en-nz": 75,
	"./en-nz.js": 75,
	"./eo": 76,
	"./eo.js": 76,
	"./es": 77,
	"./es-do": 78,
	"./es-do.js": 78,
	"./es-us": 79,
	"./es-us.js": 79,
	"./es.js": 77,
	"./et": 80,
	"./et.js": 80,
	"./eu": 81,
	"./eu.js": 81,
	"./fa": 82,
	"./fa.js": 82,
	"./fi": 83,
	"./fi.js": 83,
	"./fo": 84,
	"./fo.js": 84,
	"./fr": 85,
	"./fr-ca": 86,
	"./fr-ca.js": 86,
	"./fr-ch": 87,
	"./fr-ch.js": 87,
	"./fr.js": 85,
	"./fy": 88,
	"./fy.js": 88,
	"./gd": 89,
	"./gd.js": 89,
	"./gl": 90,
	"./gl.js": 90,
	"./gom-latn": 91,
	"./gom-latn.js": 91,
	"./gu": 92,
	"./gu.js": 92,
	"./he": 93,
	"./he.js": 93,
	"./hi": 94,
	"./hi.js": 94,
	"./hr": 95,
	"./hr.js": 95,
	"./hu": 96,
	"./hu.js": 96,
	"./hy-am": 97,
	"./hy-am.js": 97,
	"./id": 98,
	"./id.js": 98,
	"./is": 99,
	"./is.js": 99,
	"./it": 100,
	"./it.js": 100,
	"./ja": 101,
	"./ja.js": 101,
	"./jv": 102,
	"./jv.js": 102,
	"./ka": 103,
	"./ka.js": 103,
	"./kk": 104,
	"./kk.js": 104,
	"./km": 105,
	"./km.js": 105,
	"./kn": 106,
	"./kn.js": 106,
	"./ko": 107,
	"./ko.js": 107,
	"./ky": 108,
	"./ky.js": 108,
	"./lb": 109,
	"./lb.js": 109,
	"./lo": 110,
	"./lo.js": 110,
	"./lt": 111,
	"./lt.js": 111,
	"./lv": 112,
	"./lv.js": 112,
	"./me": 113,
	"./me.js": 113,
	"./mi": 114,
	"./mi.js": 114,
	"./mk": 115,
	"./mk.js": 115,
	"./ml": 116,
	"./ml.js": 116,
	"./mn": 117,
	"./mn.js": 117,
	"./mr": 118,
	"./mr.js": 118,
	"./ms": 119,
	"./ms-my": 120,
	"./ms-my.js": 120,
	"./ms.js": 119,
	"./mt": 121,
	"./mt.js": 121,
	"./my": 122,
	"./my.js": 122,
	"./nb": 123,
	"./nb.js": 123,
	"./ne": 124,
	"./ne.js": 124,
	"./nl": 125,
	"./nl-be": 126,
	"./nl-be.js": 126,
	"./nl.js": 125,
	"./nn": 127,
	"./nn.js": 127,
	"./pa-in": 128,
	"./pa-in.js": 128,
	"./pl": 129,
	"./pl.js": 129,
	"./pt": 130,
	"./pt-br": 131,
	"./pt-br.js": 131,
	"./pt.js": 130,
	"./ro": 132,
	"./ro.js": 132,
	"./ru": 133,
	"./ru.js": 133,
	"./sd": 134,
	"./sd.js": 134,
	"./se": 135,
	"./se.js": 135,
	"./si": 136,
	"./si.js": 136,
	"./sk": 137,
	"./sk.js": 137,
	"./sl": 138,
	"./sl.js": 138,
	"./sq": 139,
	"./sq.js": 139,
	"./sr": 140,
	"./sr-cyrl": 141,
	"./sr-cyrl.js": 141,
	"./sr.js": 140,
	"./ss": 142,
	"./ss.js": 142,
	"./sv": 143,
	"./sv.js": 143,
	"./sw": 144,
	"./sw.js": 144,
	"./ta": 145,
	"./ta.js": 145,
	"./te": 146,
	"./te.js": 146,
	"./tet": 147,
	"./tet.js": 147,
	"./tg": 148,
	"./tg.js": 148,
	"./th": 149,
	"./th.js": 149,
	"./tl-ph": 150,
	"./tl-ph.js": 150,
	"./tlh": 151,
	"./tlh.js": 151,
	"./tr": 152,
	"./tr.js": 152,
	"./tzl": 153,
	"./tzl.js": 153,
	"./tzm": 154,
	"./tzm-latn": 155,
	"./tzm-latn.js": 155,
	"./tzm.js": 154,
	"./ug-cn": 156,
	"./ug-cn.js": 156,
	"./uk": 157,
	"./uk.js": 157,
	"./ur": 158,
	"./ur.js": 158,
	"./uz": 159,
	"./uz-latn": 160,
	"./uz-latn.js": 160,
	"./uz.js": 159,
	"./vi": 161,
	"./vi.js": 161,
	"./x-pseudo": 162,
	"./x-pseudo.js": 162,
	"./yo": 163,
	"./yo.js": 163,
	"./zh-cn": 164,
	"./zh-cn.js": 164,
	"./zh-hk": 165,
	"./zh-hk.js": 165,
	"./zh-tw": 166,
	"./zh-tw.js": 166
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 197;

/***/ }),

/***/ 198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"calendar"},[_c('button',{staticClass:"calendar__btn calendar__btn--previous",attrs:{"title":"Предыдущий день"},on:{"click":_vm.removeOneDay}},[_vm._v("Назад\n    "),_c('svg',{staticClass:"calendar__icon",attrs:{"width":"10","height":"10"}},[_c('use',{attrs:{"x":"0","y":"0","xlink:href":"#icon-arrow"}})])]),_vm._v(" "),_c('time',{staticClass:"calendar__date",attrs:{"title":"Выберите дату"}},[_c('datepicker',{attrs:{"language":_vm.language,"monday-first":true,"placeholder":_vm.getCalendarPlaceholder,"input-class":'calendar__datepicker',"calendar-class":'calendar__calendar',"format":_vm.customFormatter,"highlighted":{
                  days: [6, 0],
                }},on:{"input":_vm.setSelectedDate},model:{value:(_vm.now),callback:function ($$v) {_vm.now=$$v},expression:"now"}})],1),_vm._v(" "),_c('button',{staticClass:"calendar__btn calendar__btn--next",attrs:{"title":"Следующий день"},on:{"click":_vm.addOneDay}},[_vm._v("Вперед\n    "),_c('svg',{staticClass:"calendar__icon",attrs:{"width":"10","height":"10"}},[_c('use',{attrs:{"x":"0","y":"0","xlink:href":"#icon-arrow"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 199:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"page-header"},[_c('div',{staticClass:"page-header__inner"},[_vm._m(0),_vm._v(" "),_c('button',{staticClass:"page-header__btn page-header__btn--hidden btn",attrs:{"type":"button","title":"Открыть попап"},on:{"click":_vm.openNewEventModal}},[_vm._v("Создать встречу")])]),_vm._v(" "),_c('calendar')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"page-header__link",attrs:{"href":"/"}},[_c('img',{staticClass:"page-header__logo",attrs:{"src":__webpack_require__(200),"alt":"Yandex Переговорки","width":"175","height":"26"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.774e34d.svg";

/***/ }),

/***/ 201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart_vue__ = __webpack_require__(167);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_458cad87_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Chart_vue__ = __webpack_require__(236);
function injectStyle (ssrContext) {
  __webpack_require__(202)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_458cad87_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Chart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 202:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Timeline_vue__ = __webpack_require__(168);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_970b6258_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Timeline_vue__ = __webpack_require__(227);
function injectStyle (ssrContext) {
  __webpack_require__(204)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Timeline_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_970b6258_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Timeline_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 204:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"timeline"},[_c('time',{staticClass:"timeline__time timeline__current",style:({'left': _vm.getTimelineLeftPosition})},[_vm._v(_vm._s(_vm.getCurrentTime))]),_vm._v(" "),_vm._l((_vm.times),function(time){return _c('time',{staticClass:"timeline__time",class:{'timeline__time--past': time.isPast}},[_vm._v("\n    "+_vm._s(time.time)+":00\n  ")])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Event_vue__ = __webpack_require__(178);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40378a0c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Event_vue__ = __webpack_require__(234);
function injectStyle (ssrContext) {
  __webpack_require__(229)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Event_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40378a0c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Event_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 229:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"event",class:{'event--opened': _vm.isOpened},style:({left: _vm.getLeftPosition, top: _vm.getTopPosition})},[(_vm.getCurrentEvent != null)?_c('div',{staticClass:"event__inner"},[_c('div',{staticClass:"event__heading"},[_c('span',{staticClass:"event__title"},[_vm._v(_vm._s(_vm.getCurrentEvent.theme))]),_vm._v(" "),_c('button',{staticClass:"event__btn",attrs:{"title":"Редактировать встречу"},on:{"click":_vm.editSelectedEvent}},[_vm._v("Редактировать\n        "),_c('svg',{staticClass:"event__icon",attrs:{"width":"12","height":"12"}},[_c('use',{attrs:{"x":"0","y":"0","xlink:href":"#icon-pen"}})])])]),_vm._v(" "),_c('div',{staticClass:"event__info"},[_c('time',{staticClass:"event__date"},[_vm._v(_vm._s(_vm.getCurrentEventDate))]),_vm._v(",\n      "),_c('span',{staticClass:"event__time"},[_vm._v(_vm._s(_vm.getCurrentEvent.startTime))]),_vm._v(" –\n      "),_c('span',{staticClass:"event__time"},[_vm._v(_vm._s(_vm.getCurrentEvent.endTime))]),_vm._v("\n      •\n      "),_c('span',{staticClass:"event__room"},[_vm._v(_vm._s(_vm.getCurrentEvent.room))])]),_vm._v(" "),_c('div',{staticClass:"event__participants"},[_vm._m(0),_vm._v(" и \n      "),_c('span',{staticClass:"event__count"},[_vm._v(_vm._s(_vm.getMembersCount))]),_vm._v("\n       "+_vm._s(_vm.getCorrectEnding(_vm.getMembersCount, ['участник', 'участника', 'участников']))+"\n    ")])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"event__host"},[_c('img',{staticClass:"event__img",attrs:{"src":__webpack_require__(235),"alt":"Дарт Вейдер"}}),_vm._v(" "),_c('span',{staticClass:"event__name"},[_vm._v("Вы")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/spider-man.82d6ccb.jpg";

/***/ }),

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"page-content"},[_c('section',{staticClass:"chart",on:{"scroll":function($event){_vm.setScrollLeft($event)}}},[_c('timeline'),_vm._v(" "),_vm._l((_vm.rooms),function(room,index){return _c('div',{key:room.id,staticClass:"chart__floor"},[_c('div',{staticClass:"chart__heading"},[_c('div',{staticClass:"chart__block"},[_c('span',{staticClass:"chart__title"},[_vm._v(_vm._s(room.floor)+" этаж")])])]),_vm._v(" "),_vm._l((room.roomList),function(roomData){return _c('div',{staticClass:"room"},[_c('div',{staticClass:"room__row"},[_vm._l((17),function(cell,index){return _c('div',{key:index,staticClass:"room__cell",attrs:{"data-start":index+7,"data-end":index+8,"data-room":roomData.roomName,"data-floor":room.floor,"title":"Создать переговорку"},on:{"click":function($event){_vm.openNewEventModal($event)}}})}),_vm._v(" "),_vm._l((_vm.getEventsList),function(taken,index){return (taken.room === roomData.roomName && taken.date === _vm.getSelectedDate)?_c('div',{staticClass:"room__cell--taken",style:({
                width: _vm.getWidth(taken) + 'px',
                left: _vm.getLeftPosition(taken) + 'px'
               }),attrs:{"title":"Показать информацию"},on:{"click":function($event){_vm.showEventPopup($event, taken, index)}}},[(_vm.clicked[index])?_c('event'):_vm._e()],1):_vm._e()})],2),_vm._v(" "),_c('div',{staticClass:"room__inner",class:{'room__inner--scrolled' : _vm.isScrolled}},[_c('span',{staticClass:"room__name",class:{'room__name--scrolled' : _vm.isScrolled}},[_vm._v("\n                "+_vm._s(roomData.roomName)+"\n          ")]),_vm._v(" "),_c('span',{staticClass:"room__count",class:{'room__count--scrolled' : _vm.isScrolled}},[_vm._v("\n             "+_vm._s(roomData.roomCount)+"\n          ")])])])})],2)})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewEvent_vue__ = __webpack_require__(179);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce3f2cca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewEvent_vue__ = __webpack_require__(259);
function injectStyle (ssrContext) {
  __webpack_require__(238)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewEvent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce3f2cca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewEvent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 238:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventDeletePopup_vue__ = __webpack_require__(181);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17c63c74_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventDeletePopup_vue__ = __webpack_require__(258);
function injectStyle (ssrContext) {
  __webpack_require__(257)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventDeletePopup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17c63c74_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventDeletePopup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 257:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"event-delete",class:{'event-delete--opened': _vm.getEventDeleteModal}},[_c('div',{staticClass:"event-delete__inner"},[_c('span',{staticClass:"event-delete__title"},[_vm._v("Встреча будет удалена безвозвратно")]),_vm._v(" "),_c('div',{staticClass:"event-delete__actions"},[_c('button',{staticClass:"event-delete__btn event-delete__btn--margin btn",attrs:{"type":"button","title":"Отменить удаление"},on:{"click":_vm.setEventDeleteModal}},[_vm._v("\n        Отмена\n      ")]),_vm._v(" "),_c('button',{staticClass:"event-delete__btn btn",attrs:{"type":"button","title":"Удалить встречу"},on:{"click":_vm.deleteCurrentEvent}},[_vm._v("\n        Удалить\n      ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"event-form",class:{'event-form--opened' : _vm.isModalOpened}},[_c('form',{staticClass:"event-form__form",attrs:{"method":"#","autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();return _vm.submitRoom($event)}}},[_c('div',{staticClass:"event-form__box"},[(!_vm.getEditState)?_c('span',{staticClass:"event-form__title"},[_vm._v("\n    Новая встреча\n    ")]):_c('span',{staticClass:"event-form__title"},[_vm._v("\n    Редактирование встречи\n    ")]),_vm._v(" "),_c('button',{staticClass:"event-form__button",attrs:{"type":"button","title":"Закрыть попап"},on:{"click":_vm.closeNewEventModal}},[_vm._v("Закрыть\n        "),_c('svg',{staticClass:"event-form__icon",attrs:{"width":"10","height":"10"}},[_c('use',{attrs:{"x":"0","y":"0","xlink:href":"#icon-cross"}})])])]),_vm._v(" "),_c('div',{staticClass:"event-form__block event-form__block--mr"},[_c('label',{staticClass:"event-form__label",attrs:{"for":"theme"}},[_vm._v("Тема")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentTheme),expression:"currentTheme"}],staticClass:"event-form__input",attrs:{"type":"text","id":"theme","name":"theme","required":"","placeholder":"О чем будете говорить?"},domProps:{"value":(_vm.currentTheme)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentTheme=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"event-form__error"},[_vm._v("\n        "+_vm._s(_vm.themeValidation)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"event-form__block event-form__block--mb event-form__block--flex"},[_c('div',{staticClass:"event-form__wrapper"},[_c('label',{staticClass:"event-form__label",attrs:{"for":"date"}},[_vm._v("Дата и время")]),_vm._v(" "),_c('datepicker',{attrs:{"language":_vm.language,"id":'date',"value":_vm.getSelectedDate,"monday-first":true,"placeholder":"Дата встречи","input-class":'event-form__input event-form__input--width',"calendar-class":'event-form__calendar',"format":_vm.customFormatter,"highlighted":{
                  days: [6, 0],
                }},on:{"input":_vm.changeSelectedDate}})],1),_vm._v(" "),_c('span',{staticClass:"event-form__error event-form__error--width"},[_vm._v("\n        "+_vm._s(_vm.dateValidation)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"event-form__inner"},[_c('div',{staticClass:"event-form__holder"},[_c('label',{staticClass:"event-form__label event-form__label--hidden",attrs:{"for":"start"}},[_vm._v("Начало")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startTime),expression:"startTime"}],staticClass:"event-form__input",attrs:{"type":"text","id":"start","placeholder":"00:00","name":"start","pattern":"([01]?[0-9]|2[0-3]):[0-5][0-9]","required":""},domProps:{"value":(_vm.startTime)},on:{"keypress":function($event){_vm.startTimeKeyPressed($event)},"input":function($event){if($event.target.composing){ return; }_vm.startTime=$event.target.value}}})]),_vm._v(" "),_c('span',{staticClass:"event-form__dash"},[_vm._v("–")]),_vm._v(" "),_c('div',{staticClass:"event-form__holder"},[_c('label',{staticClass:"event-form__label event-form__label--hidden",attrs:{"for":"end"}},[_vm._v("Конец")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endTime),expression:"endTime"}],staticClass:"event-form__input",attrs:{"type":"text","id":"end","placeholder":"00:00","name":"end","pattern":"([01]?[0-9]|2[0-3]):[0-5][0-9]","required":""},domProps:{"value":(_vm.endTime)},on:{"keypress":function($event){_vm.endTimeKeyPressed($event)},"input":function($event){if($event.target.composing){ return; }_vm.endTime=$event.target.value}}})]),_vm._v(" "),_c('span',{staticClass:"event-form__error event-form__error--bottom"},[_vm._v("\n        "+_vm._s(_vm._f("formatMessage")(_vm.timeValidation))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"event-form__block event-form__block--mb event-form__block--mr"},[_c('label',{staticClass:"event-form__label",attrs:{"for":"members"}},[_vm._v("Участники")]),_vm._v(" "),_c('v-select',{attrs:{"value":_vm.selectedMembers,"id":"members","options":_vm.getAllMembers,"multiple":"","max-height":'136px',"placeholder":'Например, Тор Одинович'},on:{"input":_vm.setSelectedMembers},scopedSlots:_vm._u([{key:"option",fn:function(option){return [_c('img',{staticClass:"event-form__img event-form__img--static",attrs:{"src":("../../static/img/faces/" + (option.avatar) + ".jpg"),"alt":option.name}}),_vm._v(" "),_c('span',{staticClass:"event-form__name"},[_vm._v("\n            "+_vm._s(option.name)+"\n          ")]),_vm._v(" "),_c('span',{staticClass:"event-form__person-floor"},[_vm._v("\n           • "+_vm._s(option.floor)+" этаж\n          ")])]}}])},[_c('span',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v("Нет участников 😖")])]),_vm._v(" "),_c('span',{staticClass:"event-form__error"},[_vm._v("\n        "+_vm._s(_vm.membersValidation)+"\n        ")]),_vm._v(" "),(_vm.getSelectedMembers.length !== 0)?_c('ul',{staticClass:"event-form__list"},_vm._l((_vm.getSelectedMembers),function(member){return _c('li',{staticClass:"event-form__item"},[_c('img',{staticClass:"event-form__img",attrs:{"src":("../../static/img/faces/" + (member.avatar) + ".jpg"),"alt":member.name}}),_vm._v(" "),_c('span',{staticClass:"event-form__name event-form__name--padding"},[_vm._v(_vm._s(member.name))]),_vm._v(" "),_c('button',{staticClass:"event-form__button",attrs:{"type":"button"},on:{"click":function($event){_vm.deleteSelectedMember(member.name)}}},[_c('svg',{staticClass:"event-form__icon",attrs:{"width":"10","height":"10"}},[_c('use',{attrs:{"x":"0","y":"0","xlink:href":"#icon-cross"}})])])])})):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"event-form__block"},[_c('span',{staticClass:"event-form__label"},[_vm._v("Выбранная переговорка")]),_vm._v(" "),(_vm.getCurrentFloor)?_c('ul',{staticClass:"event-form__rooms"},[_c('li',{staticClass:"event-form__room event-form__room--selected"},[_c('div',{staticClass:"event-form__duration"},[_c('time',{staticClass:"event-form__time"},[_vm._v(_vm._s(_vm.startTime))]),_vm._v("\n            –\n            "),_c('time',{staticClass:"event-form__time"},[_vm._v(_vm._s(_vm.endTime))])]),_vm._v(" "),_c('span',{staticClass:"event-form__name"},[_vm._v(_vm._s(_vm.getCurrentRoom))]),_vm._v("\n           • \n          "),_c('span',{staticClass:"event-form__floor"},[_vm._v(_vm._s(_vm.getCurrentFloor)+" этаж")]),_vm._v(" "),(_vm.getCurrentRoom != null)?_c('button',{staticClass:"event-form__button event-form__button--margin",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.removeCurrentRoom($event)}}},[_vm._v("Закрыть\n            "),_c('svg',{staticClass:"event-form__icon",attrs:{"width":"10","height":"10"}},[_c('use',{attrs:{"x":"0","y":"0","xlink:href":"#icon-cross"}})])]):_vm._e()])]):_c('ul',{staticClass:"event-form__rooms"},_vm._l((_vm.freeRooms),function(room){return _c('li',{staticClass:"event-form__room",on:{"click":function($event){_vm.setCurrentRoom(room.roomName, room.floor)}}},[_c('div',{staticClass:"event-form__duration"},[_c('time',{staticClass:"event-form__time"},[_vm._v(_vm._s(_vm.startTime))]),_vm._v("\n            –\n            "),_c('time',{staticClass:"event-form__time"},[_vm._v(_vm._s(_vm.endTime))])]),_vm._v(" "),_c('span',{staticClass:"event-form__name"},[_vm._v(_vm._s(room.roomName))]),_vm._v("\n           • \n          "),_c('span',{staticClass:"event-form__floor"},[_vm._v(_vm._s(room.floor)+" этаж")])])})),_vm._v(" "),_c('span',{staticClass:"event-form__error event-form__error--relative"},[_vm._v("\n        "+_vm._s(_vm.roomValidation)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"event-form__actions"},[_c('button',{staticClass:"event-form__btn event-form__btn--grey btn",attrs:{"type":"button","title":"Закрыть попап"},on:{"click":_vm.closeNewEventModal}},[_vm._v("Отмена\n      ")]),_vm._v(" "),(_vm.getEditState)?_c('button',{staticClass:"event-form__btn btn",attrs:{"type":"button","title":"Удалить текущую встречу"},on:{"click":_vm.setEventDeleteModal}},[_vm._v("\n        Удалить встречу\n      ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"event-form__btn btn",class:{'event-form__btn--disabled': !_vm.isFormValid},attrs:{"type":"submit","disabled":!_vm.isFormValid,"title":"Создать встречу"}},[_vm._v("\n        Создать встречу\n      ")])])]),_vm._v(" "),_c('event-delete')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventCreated_vue__ = __webpack_require__(182);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8178a30_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventCreated_vue__ = __webpack_require__(262);
function injectStyle (ssrContext) {
  __webpack_require__(261)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventCreated_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8178a30_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventCreated_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 261:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"event-created",class:{'event-created--opened': _vm.getEventCreatedModal}},[_c('div',{staticClass:"event-created__inner"},[_c('span',{staticClass:"event-created__title"},[_vm._v("Встреча создана")]),_vm._v(" "),_c('div',{staticClass:"event-created__info"},[_c('span',{staticClass:"event-created__date"},[_vm._v(_vm._s(_vm.getSelectedDate))]),_vm._v(",\n      "),_c('div',{staticClass:"event-created__duration"},[_c('span',{staticClass:"event-created__time"},[_vm._v(_vm._s(_vm.getStartTime))]),_vm._v("\n        –\n        "),_c('span',{staticClass:"event-created__time"},[_vm._v(_vm._s(_vm.getEndTime))])]),_vm._v(" "),_c('div',{staticClass:"event-created__place"},[_c('span',{staticClass:"event-created__room"},[_vm._v(_vm._s(_vm.getCurrentRoom))]),_vm._v("\n        •\n        "),_c('span',{staticClass:"event-created__floor"},[_vm._v(_vm._s(_vm.getCurrentFloor)+" этаж")])])]),_vm._v(" "),_c('button',{staticClass:"event-created__btn btn",attrs:{"type":"button","title":"Закрыть попап"},on:{"click":_vm.setEventCreatedModal}},[_vm._v("\n      Хорошо\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('page-header'),_vm._v(" "),_c('chart'),_vm._v(" "),(_vm.getNewEventModal)?_c('new-event'):_vm._e(),_vm._v(" "),(_vm.getEventCreatedModal)?_c('event-created'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__newEvent__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__eventPopup__ = __webpack_require__(272);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    shared: __WEBPACK_IMPORTED_MODULE_2__shared__["a" /* default */],
    newEvent: __WEBPACK_IMPORTED_MODULE_3__newEvent__["a" /* default */],
    eventPopup: __WEBPACK_IMPORTED_MODULE_4__eventPopup__["a" /* default */]
  },
  state: {},
  mutations: {},
  actions: {},
  getters: {},
  strict: "production" !== 'production'
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(13);


/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    eventsList: [],
    now: new Date(),
    selectedDate: new Date(),
    isOpenedNewEventModal: false,
    isOpenedEventCreatedModal: false,
    isOpenedEventDeleteModal: false,
    isEdit: false,
    editIndex: null
  },
  mutations: {
    setEdit: function setEdit(state, payload) {
      state.isEdit = payload;
    },
    setEditIndex: function setEditIndex(state, payload) {
      state.editIndex = payload;
    },
    setDate: function setDate(state, payload) {
      state.now = payload;
    },
    setSelectedDate: function setSelectedDate(state, payload) {
      state.selectedDate = payload;
    },
    setNewEventModal: function setNewEventModal(state, payload) {
      state.isOpenedNewEventModal = payload;
    },
    setEventCreatedModal: function setEventCreatedModal(state, payload) {
      state.isOpenedEventCreatedModal = payload;
    },
    setEventDeleteModal: function setEventDeleteModal(state, payload) {
      state.isOpenedEventDeleteModal = payload;
    },
    setNewEvent: function setNewEvent(state, payload) {
      state.eventsList.push(payload);
    },
    updateEvent: function updateEvent(state, payload) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state.eventsList, state.editIndex, payload);
    },
    deleteCurrentEvent: function deleteCurrentEvent(state) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].delete(state.eventsList, state.editIndex);
    }
  },
  getters: {
    getCurrentDate: function getCurrentDate(state) {
      return state.now;
    },
    getSelectedDate: function getSelectedDate(state) {
      return state.selectedDate;
    },
    getNewEventModal: function getNewEventModal(state) {
      return state.isOpenedNewEventModal;
    },
    getEventCreatedModal: function getEventCreatedModal(state) {
      return state.isOpenedEventCreatedModal;
    },
    getEventDeleteModal: function getEventDeleteModal(state) {
      return state.isOpenedEventDeleteModal;
    },
    getEventsList: function getEventsList(state) {
      return state.eventsList;
    },
    getEditState: function getEditState(state) {
      return state.isEdit;
    },
    getEditIndex: function getEditIndex(state) {
      return state.editIndex;
    }
  }
});

/***/ }),

/***/ 267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(13);





/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    id: 0,
    currentRoom: null,
    startTime: null,
    endTime: null,
    currentFloor: null,
    currentTheme: null,
    selectedMembers: {},
    allMembers: [{
      name: 'Человек-паук',
      avatar: 'spider-man',
      label: 'Человек-паук',
      floor: 1
    }, {
      name: 'Дедпул',
      avatar: 'deadpool',
      label: 'Дедпул',
      floor: 2
    }, {
      name: 'Веном',
      avatar: 'venom',
      label: 'Веном',
      floor: 3
    }, {
      name: 'Железный человек',
      avatar: 'ironman',
      label: 'Желеный человек',
      floor: 3
    }, {
      name: 'Капитан Америка',
      avatar: 'captain-america',
      label: 'Капитан Америка',
      floor: 2
    }, {
      name: 'Халк',
      avatar: 'hulk',
      label: 'Халк',
      floor: 1
    }, {
      name: 'Бэтмен',
      avatar: 'batman',
      label: 'Бэтмен',
      floor: 2
    }]
  },
  mutations: {
    setId: function setId(state, payload) {
      state.id += payload;
    },
    setCurrentRoom: function setCurrentRoom(state, payload) {
      state.currentRoom = payload;
    },
    setStartTime: function setStartTime(state, payload) {
      state.startTime = payload;
    },
    setEndTime: function setEndTime(state, payload) {
      state.endTime = payload;
    },
    setCurrentFloor: function setCurrentFloor(state, payload) {
      state.currentFloor = payload;
    },
    setSelectedMembers: function setSelectedMembers(state, payload) {
      state.selectedMembers = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, state.selectedMembers, payload);
    },
    deleteSelectedMember: function deleteSelectedMember(state, payload) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(state.selectedMembers).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        if (value.name === payload) {
          __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].delete(state.selectedMembers, key);
        }
      });
    },
    clearSelectedMembers: function clearSelectedMembers(state) {
      state.selectedMembers = {};
    },
    setCurrentTheme: function setCurrentTheme(state, payload) {
      state.currentTheme = payload;
    }
  },
  actions: {},
  getters: {
    getId: function getId(state) {
      return state.id;
    },
    getCurrentRoom: function getCurrentRoom(state) {
      return state.currentRoom;
    },
    getStartTime: function getStartTime(state) {
      return state.startTime;
    },
    getEndTime: function getEndTime(state) {
      return state.endTime;
    },
    getCurrentFloor: function getCurrentFloor(state) {
      return state.currentFloor;
    },
    getAllMembers: function getAllMembers(state) {
      return state.allMembers;
    },
    getSelectedMembers: function getSelectedMembers(state) {
      return state.selectedMembers;
    },
    getCurrentTheme: function getCurrentTheme(state) {
      return state.currentTheme;
    }
  }
});

/***/ }),

/***/ 272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    isEventOpened: false,
    currentEvent: null
  },
  mutations: {
    setEventModal: function setEventModal(state, payload) {
      state.isEventOpened = payload;
    },
    setCurrentEvent: function setCurrentEvent(state, payload) {
      state.currentEvent = payload;
    }
  },
  getters: {
    getEventModal: function getEventModal(state) {
      return state.isEventOpened;
    },
    getCurrentEvent: function getCurrentEvent(state) {
      return state.currentEvent;
    }
  }
});

/***/ }),

/***/ 273:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 39:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PageHeader__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Chart__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_NewEvent__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_EventCreated__ = __webpack_require__(260);
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    pageHeader: __WEBPACK_IMPORTED_MODULE_0__components_PageHeader__["a" /* default */],
    Chart: __WEBPACK_IMPORTED_MODULE_1__components_Chart__["a" /* default */],
    NewEvent: __WEBPACK_IMPORTED_MODULE_2__components_NewEvent__["a" /* default */],
    EventCreated: __WEBPACK_IMPORTED_MODULE_3__components_EventCreated__["a" /* default */]
  },
  mounted: function mounted() {
    var _this = this;

    setInterval(function () {
      _this.$store.commit('setDate', new Date());
    }, 1000);
  },

  computed: {
    getNewEventModal: function getNewEventModal() {
      return this.$store.getters.getNewEventModal;
    },
    getEventCreatedModal: function getEventCreatedModal() {
      return this.$store.getters.getEventCreatedModal;
    }
  }
});

/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Calendar__ = __webpack_require__(194);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PageHeader',
  components: {
    Calendar: __WEBPACK_IMPORTED_MODULE_0__Calendar__["a" /* default */]
  },
  methods: {
    openNewEventModal: function openNewEventModal() {
      this.$store.commit('setCurrentTheme', null);
      this.$store.commit('setCurrentRoom', null);
      this.$store.commit('setEndTime', null);
      this.$store.commit('setStartTime', null);
      this.$store.commit('setCurrentFloor', null);
      this.$store.commit('clearSelectedMembers');
      this.$store.commit('setNewEventModal', true);
    }
  }
});

/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      language: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["a" /* ru */],
      now: ''
    };
  },

  name: 'Calendar',
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__["a" /* default */]
  },
  methods: {
    customFormatter: function customFormatter(date) {
      __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('ru');
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format('DD MMMM');
    },
    addOneDay: function addOneDay() {
      var result = this.now || new Date();
      result.setDate(result.getDate() + 1);
      this.now = new Date(result);
      this.$store.commit('setSelectedDate', this.now);
    },
    removeOneDay: function removeOneDay() {
      var result = this.now || new Date();
      result.setDate(result.getDate() - 1);
      this.now = new Date(result);
      this.$store.commit('setSelectedDate', this.now);
    },
    setSelectedDate: function setSelectedDate() {
      this.$store.commit('setSelectedDate', this.now);
    }
  },
  computed: {
    getCalendarPlaceholder: function getCalendarPlaceholder() {
      var now = this.$store.getters.getCurrentDate;
      __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('ru');
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(now).format('DD MMM') + ' \u2022 \u0421\u0435\u0433\u043E\u0434\u043D\u044F';
    }
  }
});

/***/ })

},[183]);


// WEBPACK FOOTER //
// static/js/app.437ce9686b55049575c3.js